import React, { useMemo } from 'react';
import { Field } from 'redux-form';
import { TimeMap } from '../../elements-date-time/data/time-data';
import SelectField from '../../shared-components/reduxForms/fields/SelectField/SelectField';

export const CateringDeliveryTimeSelect = ({ bookingStart, bookingEnd }) => {
  const options = useMemo(() => {
    const TimeMapValues = Object.values(TimeMap);
    const startTimeIndex = TimeMapValues.findIndex(
      (timeObj) =>
        timeObj.time.toLowerCase() ===
        bookingStart?.display?.time?.toLowerCase()
    );
    const endTimeIndex = TimeMapValues.slice(startTimeIndex).findIndex(
      (timeObj) =>
        timeObj.time.toLowerCase() === bookingEnd?.display?.time?.toLowerCase()
    );

    // only allow time options between booking start and 1 hour before end time
    return TimeMapValues.slice(
      startTimeIndex,
      startTimeIndex + (endTimeIndex - 1)
    ).map((timeObj) => {
      const hours = timeObj.h < 10 ? `0${timeObj.h}` : timeObj.h;
      const minutes = timeObj.m < 10 ? `0${timeObj.m}` : timeObj.m;
      return {
        value: `${hours}:${minutes}:00`,
        label: timeObj.time
      };
    });
  }, []);

  return (
    <div>
      <label htmlFor="catering-delivery_time" className="tw-body-2-m no-margin">
        Please select a time for delivery
      </label>
      <p className="catering-delivery-select-subtext no-margin">
        Your order will be delivered within 30 minutes of the selected time.
      </p>
      <div className="catering-delivery-select-wrap">
        <Field
          id="deliveryTime"
          name="deliveryTime"
          placeholder="Select time"
          component={SelectField}
          options={options}
          menuShouldScrollIntoView={false}
        />
      </div>
    </div>
  );
};
